<template>
<div id="header" :class="{'navBarShadow':scrollType&&is_PC}">
    <!-- PC端样式 -->
    <div class="wrapper" v-if="is_PC">
        <div class="content">

            <!-- logo -->
            <!-- <transition name="header-top"> -->
            <div id="headTop">
                <a href="/" id="logo">
                    <img src="static/img/logo.png" height="72" />
                </a>

                <!-- logo -->
                <!-- 联系方式 -->
                <div id="hcontact" v-if="schoolInformation">
                    <i class="el-icon-phone"></i>
                    <p>
                        <span class="telNum">{{schoolInformation.SchoolPhone}}</span><br />
                        <a :href="'mailto:'+schoolInformation.SchoolEmail">{{schoolInformation.SchoolEmail}}</a>
                    </p>
                </div>
                <!-- 联系方式 -->
                <!-- 搜索栏 -->
                <div id="search-header" class="searchGroup">
                    <div class="search_wrap">
                        <!-- <div class="searchOnOff">
                            <i class="el-icon-search" aria-hidden="true"></i>
                        </div> -->

                        <div class="searchBox">
                            <div class="searchFormGroup">
                                <el-input v-model="searchVal" type="text" aria-label="搜索" placeholder="搜索任何你想知道的" autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="false" @keyup.enter.native="toSearch()"></el-input>
                                <!-- <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchVal" > -->
                                
                                <!-- @keyup.enter.native="toSearch()" -->
                                <div class="searchSub" @click="toSearch"><span>搜索</span><i class="fa fa-search" aria-hidden="true"></i></div>
                            </div>
                            <div class="searchClose"><i class="fa fa-times" aria-hidden="true"></i></div>
                        </div>
                    </div>
                </div>
                <!-- 搜索栏 -->
                <!-- 打开按钮 -->
                <div id="openBtn" class="fl btn">
                    <div class="lcbody">
                        <div class="lcitem top">
                            <div class="rect top"></div>
                        </div>
                        <div class="lcitem center hide">
                            <div class="rect bottom"></div>
                        </div>
                        <div class="lcitem bottom">
                            <div class="rect bottom"></div>
                        </div>
                    </div>
                </div>
                <!-- 打开按钮 -->

            </div>

            <!-- </transition> -->
            <!-- 菜单 -->
            <div class="nav">
                <el-menu :default-active="onRoutes" class="el-menu-demo" mode="horizontal" @select="handleSelect" router>
                    <el-menu-item index="home">首页</el-menu-item>
                    <el-menu-item index="course">课程体系</el-menu-item>
                    <!-- <el-menu-item index="online">免费网课</el-menu-item> -->
                    <el-menu-item index="news">新闻</el-menu-item>
                    <el-menu-item index="stage">小小剧场</el-menu-item>
                    <el-menu-item index="stars">小明星广场</el-menu-item>
                    <el-menu-item index="teachers">名师堂</el-menu-item>
                    <el-menu-item index="aboutUs">关于我们</el-menu-item>
                    <el-menu-item index="contactUs">联系我们</el-menu-item>
                    <!-- <el-submenu index="6">
                        <template slot="title">关于我们</template>
                        <el-menu-item index="aboutUs">关于我们</el-menu-item>
                        <el-menu-item index="contactUs">联系我们</el-menu-item>
                    </el-submenu> -->
                </el-menu>
                <div class="pc-login">
                    <div class="no-login" v-if="!loginType"><a href="javascript:;" class="login-btn" @click="toLogin">登录</a> / <a class="reg-btn" href="javascript:;" @click="toLogin">注册</a></div>
                    <div class="is-login" v-if="loginType">
                        <div class="user-box">
                            <!-- 站内信二期再上 -->
                            <!-- <div class="msg-box">
                                <el-badge is-dot class="item">
                                    <el-button icon="el-icon-message" circle></el-button>
                                </el-badge>
                            </div> -->
                            <el-dropdown @command="handleCommand">
                                <a href="javascript:;">
                                    <el-image :src="ip + 'media/'+user.UserImg" alt="" fit="cover"></el-image>
                                    <span class="el-dropdown-link">
                                        <span v-if="user.NikeName&&user.RealName">{{user.RealName}}</span>
                                        <span v-if="!user.NikeName&&!user.RealName">用户未登录</span>
                                        <span v-if="!user.NikeName||!user.RealName">{{user.NikeName}}{{user.RealName}}</span>
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="userPage">个人中心</el-dropdown-item>
                                        <el-dropdown-item command="outLogin" v-track-event="{category:'登出', action:'click',opt_label:'PC端登出'}">退出登录</el-dropdown-item>
                                    </el-dropdown-menu>
                                </a>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 菜单 -->
        </div>
    </div>
    <!-- PC端样式 -->
    <!-- 移动端样式 -->
    <div class="m-wrapper" v-if="!is_PC">
        <div class="m-menu" @click="drawer=!drawer" v-if="!is_return"><i class="el-icon-s-operation"></i></div>
        <div class="m-menu" @click="returnBtn()" v-if="is_return"><i class="el-icon-back"></i></div>
        <div class="m-logo"><img src="static/img/m-logo.png" alt=""></div>
        <div class="m-search" @click="is_m_search=!is_m_search"><i class="el-icon-search"></i></div>
    </div>

    <transition name="m-search-show">
        <div class="m-search-box" v-if="is_m_search">
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchVal" @keyup.enter.native="toSearch()">
            </el-input>
        </div>
    </transition>

    <transition name="m-mark-show">
        <div class="m-mark" @click="is_m_search=false" v-if="is_m_search"></div>
    </transition>

    <el-drawer v-if="!is_PC" :visible.sync="drawer" direction="ltr" :before-close="handleClose" size='80%' style="height:100%;" :modal="false">
        <el-menu :default-active="onRoutes" class="el-menu-m" mode="vertical" @select="handleSelect" router>
            <el-menu-item index="home">首页</el-menu-item>
            <el-menu-item index="course">课程体系</el-menu-item>
            <!-- <el-menu-item index="online">免费网课</el-menu-item> -->
            <el-menu-item index="news">新闻</el-menu-item>
            <el-menu-item index="stage">小小剧场</el-menu-item>
            <el-menu-item index="stars">小明星广场</el-menu-item>
            <el-menu-item index="teachers">名师堂</el-menu-item>
            <el-menu-item index="aboutUs">关于我们</el-menu-item>
            <el-menu-item index="contactUs">联系我们</el-menu-item>
            <!-- <el-submenu index="6">
                <template slot="title">关于我们</template>
                <el-menu-item index="aboutUs">关于我们</el-menu-item>
                <el-menu-item index="contactUs">联系我们</el-menu-item>
            </el-submenu> -->
        </el-menu>
    </el-drawer>
    <!-- 移动端样式 -->

</div>
</template>

<script>
export default {
    data() {
        return {
            muenindex: this.$route.path.replace("/", ""),
            //获取当前登录设备
            is_PC: this.$store.state.is_PC,
            ip: this.$store.state.ip,
            //抽屉开关
            drawer: false,
            //是否显示搜索
            is_m_search: false,
            //搜索字段
            searchVal: '',
            From: this.$route.query.From,
            //user
            // user: {
            //     NikeName: "未登录",
            //     UserImg: '@/assets/img/user-img.png'
            // },
            //是否登录
            // is_login: this.$store.state.is_login,
        };
    },
    //进入页面执行的函数
    created() {
        // this.getUser();
    },
    mounted() {

    },
    methods: {
        //获取登录用户
        // getUser() {
        //     this.user = this.$store.state.login_user
        // },

        handleSelect(key, keyPath) {
            this.muenindex = key;
            this.drawer = false;
        },

        //关闭抽屉
        handleClose(done) {
            done();
        },

        //点击头像下拉菜单
        handleCommand(command) {
            //跳转至个人中心
            if (command == 'userPage') {
                this.$router.push({
                    path: '/userPage'
                })
            }
            //退出登录
            if (command == 'outLogin') {
                this.$confirm('是否退出登录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.commit('updateIsLogin', false);
                    this.$store.commit('updateLoginPage', '/home');
                    // 清除用户缓存
                    localStorage.clear();
                    this.$router.push({
                        path: '/home'
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消退出'
                    });
                });

            }
        },
        //跳转登录页
        toLogin() {
            this.$router.push({
                path: '/login'
            })
        },
        //跳转搜索页面
        toSearch() {
            if (this.searchVal == '') {

                this.$message({
                    type: 'info',
                    message: '请输入搜索条件后再进行搜索'
                });
            } else {
                this.$store.commit('updateSearchVal', this.searchVal);
                this.$router.push({
                    path: '/search' + '?search=' + this.searchVal
                });
            }

        },
        //移动端返回按钮
        returnBtn() {
            if (this.From) {
                this.$router.push({
                    path: this.From
                })
            } else {
                this.$router.back(-1)
            }

        },

    },
    computed: {
        onRoutes() {
            return this.$route.path.replace("/", "");
        },
        //滚轮状态
        scrollType() {
            return this.$store.getters.getScrollType;
        },
        //登录状态
        loginType() {
            return this.$store.getters.getloginType;
        },
        //登录用户资料
        user() {
            if (this.$store.getters.get_login_user_data) {
                return this.$store.getters.get_login_user_data;
            } else {
                return JSON.parse(localStorage.getItem("user"));
            }
        },
        //学校信息
        schoolInformation() {
            if (this.$store.getters.get_schoolInformation) {
                return this.$store.getters.get_schoolInformation;
            } else {
                return JSON.parse(localStorage.getItem("school"));
            }
        },
        //是否显示返回上一级
        is_return() {
            return this.$store.getters.getIsReturn;
        },
        //从哪一页跳转过来
        // fromPage() {
        //     if (this.From == 'home') {
        //         return '/home';
        //     }
        // }
    },
    watch: {
        onRoutes(curVal, oldVal) {
            // this.getcurrentUserMsg()
        }
    },
}
</script>

<style scoped>
@import './header.css';


#header>>>.el-drawer__wrapper{
    height: 1vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;

}

</style>



// WEBPACK FOOTER //
// src/components/header/header.vue